import { degreesToRadians, DistanceVec2, rayIntersectHorizontal } from "./util";
export function CalcPlaceFromDiagonalY(a, y, shiftLeft = 0, shiftRight = 0, pointStart = [0, 0]) {
    const DegA = degreesToRadians(+a);
    const pointBL = pointStart;
    const pointTR = rayIntersectHorizontal(pointBL, y, DegA);
    const pointBR = [pointTR[0], pointBL[1]];
    const pointTL = [pointTR[0], pointBL[1]];
    const pointShiftLB = rayIntersectHorizontal(pointBL, -shiftLeft, DegA - Math.PI);
    const pointShiftRT = rayIntersectHorizontal(pointTR, y + shiftRight, DegA);
    const pointShiftLT = [pointShiftLB[0], pointBL[1]];
    const pointShiftRB = [pointShiftRT[0], pointBL[1]];
    const placeFromDiagonal = {
        p: {
            b: pointBL,
            t: pointTR
        },
        h: DistanceVec2(pointTR, pointBR),
        w: DistanceVec2(pointBR, pointBL),
        l: DistanceVec2(pointBL, pointTR),
        shift: {
            front: {
                h: DistanceVec2(pointShiftLB, [pointShiftLB[0], pointBL[1]]),
                w: DistanceVec2(pointShiftLB, [pointBL[0], pointShiftLB[1]]),
                l: DistanceVec2(pointShiftLB, pointBL),
                p: {
                    b: pointShiftLB,
                    t: pointShiftLT
                }
            },
            back: {
                h: DistanceVec2(pointShiftRT, [pointShiftRT[0], pointTR[1]]),
                w: DistanceVec2(pointShiftRT, [pointTR[0], pointShiftRT[1]]),
                l: DistanceVec2(pointTR, pointShiftRT),
                p: {
                    b: pointShiftRB,
                    t: pointShiftRT
                }
            }
        },
    };
    return placeFromDiagonal;
}
// export function CalcPlaceFromDiagonalIntesectDiagonal(
//     diagonal: Vec2[],
//     a: number,
//     startPoint:Vec2 = [0, 0]
// ): simpleSize {
//     const DegA = degreesToRadians(a)
//
//     const [d1, d2] = diagonal;
//
//     const x1 = d1[0];
//     const y1 = d1[1];
//     const x2 = d2[0];
//     const y2 = d2[1];
//
//     const dx = x2 - x1;
//     const dy = y2 - y1;
//
//     const cos = Math.cos(DegA);
//     const sin = Math.sin(DegA);
//
//     // Решаем систему:
//     // x1 + u*dx = t*cos
//     // y1 + u*dy = t*sin
//
//     const denom = dx * sin - dy * cos;
//
//     if (Math.abs(denom) < 1e-8) {
//         return {w:0, h:0, l:0}; // параллельны
//     }
//
//     const u = (cos * (y1) - sin * (x1)) / denom;
//
//     const ix = x1 + u * dx;
//     const iy = y1 + u * dy;
//
//     const l = Math.sqrt(ix * ix + iy * iy);
//
//     return {
//         w: ix,
//         h: iy,
//         l: l
//     };
// }
export function CalcPlaceFromDiagonalIntersectDiagonal(diagonal, a, startPoint = [0, 0]) {
    const angle = degreesToRadians(a);
    const [d1, d2] = diagonal;
    const [sx, sy] = startPoint;
    const dx = d2[0] - d1[0];
    const dy = d2[1] - d1[1];
    const dirX = Math.cos(angle);
    const dirY = Math.sin(angle);
    // Решаем:
    // d1 + u*(dx,dy) = (sx,sy) + t*(dirX,dirY)
    const denom = dx * dirY - dy * dirX;
    if (Math.abs(denom) < 1e-8) {
        return { w: 0, h: 0, l: 0 }; // параллельны
    }
    const u = ((sx - d1[0]) * dirY - (sy - d1[1]) * dirX) / denom;
    const ix = d1[0] + u * dx;
    const iy = d1[1] + u * dy;
    // длина луча от startPoint
    const l = Math.hypot(ix - sx, iy - sy);
    return {
        w: ix,
        h: iy,
        l: l
    };
}
